import { notification } from 'antd'
import i18next from 'i18next'
import { action, makeAutoObservable } from 'mobx'

import { Country } from 'shared/types/types'

import { userApi } from '../../api'
import { OfferSignParams, UserModuleKeys } from '../../types'
import { OfferUiStore } from './OfferUiStore'

const getKey = (key: string) => `${UserModuleKeys.regisgtrationPage}.${key}`

export class OfferApiStore {
  constructor(protected readonly uiStore: OfferUiStore) {
    makeAutoObservable(this)
  }

  @action
  signOfferVersion = async (params: OfferSignParams): Promise<boolean> => {
    this.uiStore.setLoading(true)
    try {
      const { success } = await userApi.signOfferVersion(params)
      return success
    } catch (error) {
      notification.error({
        message: i18next.t(getKey('Ошибка подписания оферты')),
        description: (error as Error).message,
      })
      throw error
    } finally {
      this.uiStore.setLoading(false)
    }
  }

  @action
  getOfferVersion = async (countryCode?: Country) => {
    const uiStore = this.uiStore
    const result = await userApi.getOfferVersion(countryCode)

    uiStore.setOffers(result.offers)
  }
}
